<template>
  <div v-if="totalPages >= 2" class="block w-full my-4">
    <ul class="flex flex-row items-center justify-center w-full gap-4">
      <li>
        <button @click="handleOnClick(currentPage - 1)" :disabled="currentPage < 2" title="Previous Page"
          class="flex flex-nowrap items-center gap-3 text-black hover:text-geb-dark-800 whitespace-nowrap disabled:opacity-30 disabled:pointer-events-none transition-colors duration-500 group">
          <i class="w-4 h-4 flex-shrink-0 fill-none transform rotate-90 group-hover:-translate-x-0.5 transition-transform duration-500"
            v-icon:chevron-down></i>
        </button>
      </li>

      <li class="flex gap-2">
        <button v-if="currentPage > pageRange && totalPages > pageRange" @click="handleOnClick(backNumber)"
          class="flex mr-1">
          ...
        </button>

        <div class="flex gap-2">
          <button v-for="page in pages" :key="page" @click="handleOnClick(page)" :class="[
            'text-black text-center min-w-9 px-2 py-1 text-base leading-tight transition-colors duration-500 border rounded-lg bg-white border-teal-100 hover:border-teal-200',
            page === currentPage ? 'font-semibold border-teal-200' : ''
          ]">
            {{ page }}
          </button>
        </div>


        <button v-if="currentPage + pageRange < totalPages" @click="handleOnClick(forwardNumber)" class="flex ml-1">
          ...
        </button>
      </li>

      <li>
        <button @click="handleOnClick(currentPage + 1)" :disabled="currentPage === totalPages" title="Next Page"
          class="flex flex-nowrap items-center gap-3 text-black hover:text-geb-dark-800 whitespace-nowrap disabled:opacity-30 disabled:pointer-events-none transition-colors duration-500 group">
          <i class="w-4 h-4 transform -rotate-90 flex-shrink-0 fill-none group-hover:translate-x-0.5 transition-transform duration-500"
            v-icon:chevron-down></i>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: { type: Number, required: true },
    pageRange: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    blockId: { type: String }
  },
  computed: {
    startPage() {
      const start = Math.max(
        this.currentPage - Math.floor(this.pageRange / 2),
        1
      );
      return Math.min(
        start,
        (this.totalPages > this.pageRange
          ? this.totalPages - this.pageRange
          : 1) + 1
      );
    },
    lastPage() {
      return Math.min(
        this.startPage + this.pageRange - 1,
        this.totalPages
      );
    },
    pages() {
      const arr = [];
      for (let i = this.startPage; i <= this.lastPage; i++) {
        arr.push(i);
      }
      return arr;
    },
    backNumber() {
      return Math.max(this.currentPage - this.pageRange, 1);
    },
    forwardNumber() {
      return Math.min(
        this.currentPage + this.pageRange,
        this.totalPages
      );
    }
  },
  methods: {
    handleOnClick(value) {
      if (this.blockId) {
        const element = document.getElementById(this.blockId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      this.$emit('page', value);
    },
  }
};
</script>